import React, { Component } from 'react';
import { connect } from 'react-redux';
import FilesView from './Files.view';

export class FilesContainer extends Component {

  constructor(props){
    super(props);
    this.onFilterChange = this.onFilterChange.bind(this);
    this.nextPage = this.nextPage.bind(this);
    this.previousPage = this.previousPage.bind(this);
    this.download = this.download.bind(this);
  }

  componentDidMount() {
    this.getFiles(this.props);
  }

  componentWillReceiveProps(nextProps){
    if(
      this.props.filtersFormState !== nextProps.filtersFormState ||
      this.props.page !== nextProps.page
    ){
      this.getFiles(nextProps);
    }
  }

  getFiles(props){
    const { dispatch, filtersFormState, page } = props;
    dispatch({
      type: 'FETCH_FILES',
      payload: {
        filters: filtersFormState.data,
        page: page,
      }
    });
  }

  download(file){
    const { dispatch } = this.props;
    dispatch({
      type: 'DOWNLOAD_FILE',
      payload: {
        file,
      },
    });
  }

  nextPage(){
    const { dispatch } = this.props;
    dispatch({
      type: 'FILES_NEXT_PAGE',
    });
  }

  previousPage(){
    const { dispatch } = this.props;
    dispatch({
      type: 'FILES_PREVIOUS_PAGE',
    });
  }

  onFilterChange(filtersFormState){
    const { dispatch } = this.props;
    dispatch({
      type: 'FILE_FILTERS_CHANGE',
      payload: {
        filtersFormState,
      }
    });
  }

  render() {
    return (<FilesView
      {...this.props}
      onFilterChange={this.onFilterChange}
      nextPage={this.nextPage}
      previousPage={this.previousPage}
      download={this.download}
    />);
  }

}

function mapStateToProps(state) {
  const { files } = state;
  return {
    files: files.files,
    filtersFormState: files.filtersFormState,
    page: files.page,
  };
}

export default connect(mapStateToProps)(FilesContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Files/Files.container.js